import {displayFunctions} from "./StoreTotalsDataSelections";

function getWeekEndDataFields(dataSelection, includeYago) {
    const {valueKey, yagoKey} = displayFunctions[dataSelection];
    const yagoField = includeYago && yagoKey ? ` ${yagoKey}` : '';
    return `date ${valueKey}${yagoField}`;
}

function getSalesQuery(dataSelection, retailerId, includePlu, includeIfps, includeYago, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, includeFillOnly, openStoresOnlyClause, storeIdsFilterClause, useSkipStores) {
    return `
    {
        sales:salesIngestionSummary(retailerId: ${retailerId}, includePlu: ${includePlu}, includeIfps: ${includeIfps}, includeYago: ${includeYago}, includeFilledWeeksOnly: ${includeFillOnly}, useSkipStores: ${useSkipStores}, sources: cleansed, productSnapshotOnly: ${productSnapshotOnly}${startDateClause}${endDateClause}${stateFilterClause}${openStoresOnlyClause}${storeIdsFilterClause})
        {
            stores {
                storeId
                storeName
                weekEndData{${getWeekEndDataFields(dataSelection, includeYago)}}
            }
            rollUpDates
            weekEndDates
        }
    }`;
}

function getFillQuery(dataSelection, retailerId, includePlu, includeIfps, includeYago, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, openStoresOnlyClause, storeIdsFilterClause, useSkipStores) {
    return `
    {
        fill:salesIngestionSummary(retailerId: ${retailerId}, includePlu: ${includePlu}, includeIfps: ${includeIfps}, includeYago: ${includeYago}, useSkipStores: ${useSkipStores}, sources: fill, productSnapshotOnly: ${productSnapshotOnly}${startDateClause}${endDateClause}${stateFilterClause}${openStoresOnlyClause}${storeIdsFilterClause})
        {
            stores {
                storeId
                storeName
                weekEndData{${getWeekEndDataFields(dataSelection, false)}}
            }
            rollUpDates
            weekEndDates
        }
    }`;
}

function getAveragesQuery(dataSelection, retailerId, includePlu, includeIfps, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, openStoresOnlyClause, storeIdsFilterClause) {
    return `
    {
        averages:storeSalesAverages(retailerId: ${retailerId}${startDateClause}${endDateClause}, includePlu: ${includePlu}, includeIfps: ${includeIfps}, productSnapshotOnly: ${productSnapshotOnly}${stateFilterClause}${openStoresOnlyClause}${storeIdsFilterClause})
        {
            storeId ${displayFunctions[dataSelection].averageKey}
        }
    }`;
}

function getConfigsQuery(retailerId, stateFilterClause, openStoresOnlyClause, storeIdsFilterClause) {
    return `
    {
        storeStart(retailerId: ${retailerId}) {dates{storeId, salesEndDate}}
        storeStop(retailerId: ${retailerId}) {dates{storeId, salesEndDate}}
        alwaysFill(retailerId: ${retailerId}${stateFilterClause}${openStoresOnlyClause}${storeIdsFilterClause}) {dates{storeId, salesEndDate}}
        doNotFill(retailerId: ${retailerId}${stateFilterClause}${openStoresOnlyClause}${storeIdsFilterClause}) {dates{storeId, salesEndDate}}
        storeClosures(retailerId: ${retailerId}) { storeId startDate endDate }
        stores:storesWithSkipConfiguration(retailerId: ${retailerId}, skipConfigName: "skipStoreTotals"${stateFilterClause}${openStoresOnlyClause}${storeIdsFilterClause}) { storeId storeName closedDate }
    }`;
}

export function getStoreTotalsQueries(dataSelection, retailerId, includePlu, includeIfps, includeYago, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, includeFillOnly, openStoresOnlyClause, storeIdsFilterClause, useSkipStores = false) {
    return {
        sales: getSalesQuery(dataSelection, retailerId, includePlu, includeIfps, includeYago, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, includeFillOnly, openStoresOnlyClause, storeIdsFilterClause, useSkipStores),
        fill: getFillQuery(dataSelection, retailerId, includePlu, includeIfps, includeYago, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, openStoresOnlyClause, storeIdsFilterClause, useSkipStores),
        averages: getAveragesQuery(dataSelection, retailerId, includePlu, includeIfps, productSnapshotOnly, startDateClause, endDateClause, stateFilterClause, openStoresOnlyClause, storeIdsFilterClause),
        configs: getConfigsQuery(retailerId, stateFilterClause, openStoresOnlyClause, storeIdsFilterClause)
    };
}
